import "./InputEditor.css";

export interface InputEditorProps {
  value: string;
  onChange: (value: string) => void;
  onResetToFixture: () => void;
  parseError?: string;
  disabled?: boolean;
}

/**
 * Editor de payload como texto JSON. Se analiza con JSON.parse (nunca eval ni
 * innerHTML); si el texto no es JSON válido se conserva la edición y se enlaza el
 * error al campo mediante aria-describedby, sin bloquear la escritura.
 */
export function InputEditor({
  value,
  onChange,
  onResetToFixture,
  parseError,
  disabled,
}: InputEditorProps) {
  return (
    <div className="input-editor">
      <div className="input-editor__label-row">
        <label htmlFor="input-editor-payload">Payload (JSON)</label>
        <button type="button" className="btn btn--ghost input-editor__reset" onClick={onResetToFixture}>
          Restaurar fixture
        </button>
      </div>
      <p className="input-editor__help" id="input-editor-help">
        Usa el ejemplo incluido o edítalo. El modo local no envía estos datos a ningún servidor.
      </p>
      <textarea
        id="input-editor-payload"
        className="mono input-editor__textarea"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-describedby={parseError ? "input-editor-error input-editor-help" : "input-editor-help"}
        aria-invalid={parseError ? "true" : "false"}
        spellCheck={false}
        disabled={disabled}
        rows={12}
      />
      {parseError && (
        <p id="input-editor-error" className="input-editor__error" role="alert">
          {parseError}
        </p>
      )}
    </div>
  );
}
